import { ConcreteEncodable } from "./ConcreteEncodable";

import { TenorToDateEventResponseEncoder } from "../../encoder/TenorToDateEventResponseEncoder";

import * as CubiqTS from "../../index";

export class TenorToDateEventResponse extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.module.tenor2date.announcer.TenorToDateEventResponse";

  /*FID=1*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = TenorToDateEventResponseEncoder.Instance;
    this.setEncodableType(TenorToDateEventResponse.enType);
    //Model
  }

  public toString(): string {
    return (
      "TenorToDateEventResponse[" + "errors=" + this.errors + "messageId=" + this.messageId + "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
